export enum ApprovalFlowStepActorType {
SpecificRole,
DepartmentManager,
SpecificUser,
Department,
}
